import {
  EndpointBuilder,
  EndpointDefinition,
  MutationDefinition,
  QueryDefinition,
} from '@reduxjs/toolkit/dist/query/endpointDefinitions';
import { fetchBaseQuery } from '@reduxjs/toolkit/query';
import fetch from 'isomorphic-fetch';
import queryString, { StringifiableRecord } from 'query-string-for-all';
import { Tapi } from './tapiTypes';

const baseHost = window.location
  ? window.location.protocol + '//' + window.location.host
  : 'http://localhost:3000';

export const tapiBaseUrl = `${baseHost}/tapi/v1`;

export const baseQuery = fetchBaseQuery({
  baseUrl: tapiBaseUrl,
  fetchFn: fetch,
});

export type TapiEndpointBuilder = EndpointBuilder<
  typeof baseQuery,
  never,
  'tapi'
>;

export type RequestWithParamsAndQuery<Params, Query, Body = never> = Params & {
  query?: Query;
  body?: Body;
};

export type TapiQuery<K extends keyof Tapi> = QueryDefinition<
  RequestWithParamsAndQuery<
    Tapi[K]['RequestParams'],
    Tapi[K]['RequestQuery'],
    Tapi[K]['RequestBody']
  >,
  typeof baseQuery,
  never,
  Tapi[K]['ResponseBody']
>;

export type TapiMutation<K extends keyof Tapi> = MutationDefinition<
  RequestWithParamsAndQuery<
    Tapi[K]['RequestParams'],
    Tapi[K]['RequestQuery'],
    Tapi[K]['RequestBody']
  >,
  typeof baseQuery,
  never,
  Tapi[K]['ResponseBody']
>;

export type TapiEndpointFactory<K extends keyof Tapi> = (
  builder: TapiEndpointBuilder
) => TapiQuery<K>;

export type TapiMutationFactory<K extends keyof Tapi> = (
  builder: TapiEndpointBuilder
) => TapiMutation<K>;

export const stringifyUrl = (url: string, query: StringifiableRecord) =>
  queryString.stringifyUrl({ url, query }, { arrayFormat: 'bracket' });
